import script from "./feesgroupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./feesgroupPage.vue?vue&type=script&setup=true&lang=js"

import "./feesgroupPage.vue?vue&type=style&index=0&id=69ba82e0&lang=css"

const __exports__ = script;

export default __exports__